<template>
  <article class="blog-item">
    <nuxt-link :to="{name: 'blogs-slug', params: {slug: blog.slug}}">
      <div class="gradient-border"/>
      <section class="flex">
        <img :src="image" class="w-2/3 object-cover">
        <div class="w-1/3 flex flex-col items-center justify-center text-center">
          <span class="h2 text-secondary">{{ $moment(blog.created_at).format('DD') }}</span>
          <span>{{ $moment(blog.created_at).format('MMMM') }}</span>
          <span>{{ $moment(blog.created_at).format('YYYY') }}</span>
        </div>
      </section>
      <section class="content">
        <div class="font-bold" v-text="blog.title"/>

        <div>
          Door: {{ author ? author : blog.auteur.name }}
        </div>
      </section>
    </nuxt-link>
  </article>
</template>

<script>
export default {
  props: {
    blogOverview: {
      type: Boolean,
      default: false,
    },
    blog: {
      type: Object,
      default: () => ({}),
    },
    author: {
      type: String,
      default: '',
    },
  },
  computed: {
    image() {
      if (!this.blog.active_image) {
        return '';
      }
      return this.blog.active_image.url;
    },
  },
};
</script>

<style lang="scss" scoped>
.blog-item {
  @apply w-full bg-white;
  box-shadow: 1px 1px 5px 1px rgba(222, 220, 220, 0.5);
  border: solid 1px rgb(240, 238, 238);
  img {
    height: 180px;
  }
  .content {
    @apply w-full bg-primary-lighter flex flex-col justify-center px-4;
    height: 70px;
  }
}
</style>
